module.exports = __webpack_public_path__ + "img/play-store-badge.5cfb06d1.png";